import { SxProps, Theme } from "@mui/material";

const outlinedInputSelector = [
  "& .MuiOutlinedInput-notchedOutline",
  "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline",
].join(", ");
const outlinedInputHoverSelector = [
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline",
  "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline",
].join(", ");
const outlinedInputFocusedSelector = [
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline",
  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline",
].join(", ");

const outlinedInputSx: SxProps<Theme> = {
  [outlinedInputSelector]: {
    borderColor: "divider",
  },
  [outlinedInputHoverSelector]: {
    borderColor: "divider",
  },
  [outlinedInputFocusedSelector]: {
    borderColor: "primary.main",
  },
};

const getInputVariantSx = (variant?: string, ...sx: Array<SxProps<Theme> | undefined>): SxProps<Theme> => {
  const flattenedSx = sx.flatMap((style) => {
    if (!style) return [];
    return Array.isArray(style) ? style : [style];
  });

  return variant === "outlined" ? [outlinedInputSx, ...flattenedSx] : flattenedSx;
};

export default getInputVariantSx;
